import React, { useContext, useState, useEffect, useCallback } from 'react';

import * as S from './FooterStyle';
import { ResponsiveContainer } from 'commonStyles';
import { followUsConfig, downloadConfig, FooterLinks } from '../../bizLanding/config';
import DisplayContext from 'UtilityComponents/displayContext';
import { isMobileContext } from 'UtilityComponents/Util';
import { GenericDiv, FlexDiv } from 'commonStyles';
import FooterList from './FooterList';
import landingContext from '../../bizLanding/landingContext';
import { getConfigData } from '../../bizLanding/landingApi';
import { APPLICATION_CONSTANTS, PATHS } from 'AppConstants';

const Footer = ({ isPreLoad }) => {
	const { appSsrData } = useContext(landingContext) || {};
	const [footerData, setFooterData] = useState(appSsrData?.footerData || { links: FooterLinks });
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);

	useEffect(() => {
		getDetails();
	}, []);

	const getDetails = useCallback(async () => {
		if (!appSsrData?.footerData?.links?.length) {
			const path = window.location.pathname;
			const response = await getConfigData(APPLICATION_CONSTANTS.OPEN_CONFIG_KEYS.SEO);
			const commonFooterData = response?.data?.common;
			const pathFooterData = response?.data?.[path];
			const footerData = { ...commonFooterData, ...pathFooterData };
			const footer = footerData?.links ? footerData : { links: FooterLinks };
			setFooterData(footer);
		}
	}, [appSsrData]);

	const socialMediaConfig = footerData?.followUs ? footerData.followUs : followUsConfig;

	return (
		<S.FooterWrapper>
			<GenericDiv $bg='#1a1a1a'>
				<ResponsiveContainer
					isNoBTPadd
					wrap='wrap'
					mobileDir='column'
					justify='space-between'
					isFlex='true'>
					{footerData?.article?.length && footerData.article.map((section, i) => (
						<GenericDiv key={section.heading} bottom_P='20' top_M='8'>
							<S.FooterHeadWrap justify='space-between'>
								<S.FooterLabel><S.HeadSpan>{section.heading}</S.HeadSpan></S.FooterLabel>
							</S.FooterHeadWrap>
							<S.LinkWrap mobDir='row'>
								<S.FooterItems margin='2px 10px' dangerouslySetInnerHTML={{ __html: section.description }} />
							</S.LinkWrap>
						</GenericDiv>
					))}
				</ResponsiveContainer>
				<ResponsiveContainer
					isNoBTPadd
					wrap='wrap'
					mobileDir='column'
					justify='space-between'
					isFlex='true'
					itemScope itemType={`${PATHS.SEO_SCHEMA_URL}/FAQPage`}>
					{footerData?.faqs && <S.FooterHeadWrap justify='space-between'>
						<S.FooterLabel><S.HeadSpan>Frequently Asked Questions</S.HeadSpan></S.FooterLabel>
					</S.FooterHeadWrap>}
					{footerData?.faqs?.length && footerData.faqs.map((section, i) => (
						<GenericDiv left_P='10' itemScope itemProp='mainEntity' itemType={`${PATHS.SEO_SCHEMA_URL}/Question`} key={section.heading} bottom_P='10'>
							<S.FooterHeadWrap justify='space-between'>
								<S.FooterLabel><S.HeadSpan itemProp='name' fsize='14px'>{section.heading}</S.HeadSpan></S.FooterLabel>
							</S.FooterHeadWrap>
							<S.FooterItems
								itemScope
								itemProp='acceptedAnswer'
								itemType={`${PATHS.SEO_SCHEMA_URL}/Answer`} margin='2px 10px' dangerouslySetInnerHTML={{ __html: section.description }}
							/>
						</GenericDiv>
					))}
				</ResponsiveContainer>
				<ResponsiveContainer
					isNoBTPadd
					wrap='wrap'
					mobileDir='column'
					justify='space-between'
					isFlex='true'>
					{footerData?.links?.length && footerData.links.map((section, i) => (
						<FooterList
							key={section.head}
							isMobile={isMobile}
							list={section.list}
							trackVal={section.trackVal}
							head={section.head}
							icon={section.icon}
							showDot
							linkMargin='0 2px'
							borderBottom={i < footerData.length - 1 ? '1px solid #4A4A4A' : ''}
							index={i}
							showList={(isPreLoad || !isMobile)}
						/>
					))}
				</ResponsiveContainer>
			</GenericDiv>
			<GenericDiv $bg='#000000'>
				<ResponsiveContainer
					bottom_P='90'
					top_P={isMobile ? '8' : '75'}
					wrap='wrap'
					justify={isMobile ? 'center' : 'space-between'}
					isFlex='true'>
					<FlexDiv $width='auto' directionInMobile='column'>
						<GenericDiv right_M={isMobile ? '' : '100'}>
							<FooterList
								key={socialMediaConfig.head}
								isMobile={isMobile}
								list={socialMediaConfig.list}
								trackVal={socialMediaConfig.trackVal}
								head={socialMediaConfig.head}
								showDot={false}
								linkMargin='0 2px'
								imgDim={socialMediaConfig.imgDim}
								showList
							/>
						</GenericDiv>
						<FooterList
							key={downloadConfig.head}
							isMobile={isMobile}
							list={downloadConfig.list}
							trackVal={downloadConfig.trackVal}
							showDot={false}
							mobDir='row'
							linkMargin='0 12px'
							showList
						/>
					</FlexDiv>
					<S.FooterSubHead>
						<p>© 2022 MakeMyTrip (India) Limited.</p>
						<p>Country <span>India</span></p>
					</S.FooterSubHead>
				</ResponsiveContainer>
			</GenericDiv>
		</S.FooterWrapper>
	);
};

export default Footer;
